import { render, staticRenderFns } from "./ContatoTelefoneLink.vue?vue&type=template&id=5e581582&scoped=true"
import script from "./ContatoTelefoneLink.vue?vue&type=script&lang=js"
export * from "./ContatoTelefoneLink.vue?vue&type=script&lang=js"
import style0 from "./ContatoTelefoneLink.vue?vue&type=style&index=0&id=5e581582&prod&scoped=true&lang=css"
import style1 from "./ContatoTelefoneLink.vue?vue&type=style&index=1&id=5e581582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e581582",
  null
  
)

export default component.exports